export const GET_CUSTOM_ATTRIBUTES = 'GET_CUSTOM_ATTRIBUTES';
export const getCustomAttributes = (parentType, visible) => ({
    type: GET_CUSTOM_ATTRIBUTES,
    payload: { parentType, visible }
});

export const GET_CUSTOM_ATTRIBUTES_SUCCESS = 'GET_CUSTOM_ATTRIBUTES_SUCCESS';
export const getCustomAttributesSuccess = (customAttributes=[]) => ({
    type: GET_CUSTOM_ATTRIBUTES_SUCCESS,
    payload: { customAttributes }
});

export const GET_CUSTOM_ATTRIBUTES_FAILURE = 'GET_CUSTOM_ATTRIBUTES_FAILURE';
export const getCustomAttributesFailure = (error={}) => ({
    type: GET_CUSTOM_ATTRIBUTES_FAILURE,
    payload: { error }
});

export const SET_CUSTOM_ATTRIBUTES = 'SET_CUSTOM_ATTRIBUTES';
export const setCustomAttributes = (customAttributes = []) => ({
    type: SET_CUSTOM_ATTRIBUTES,
    payload: {
        customAttributes
    }
});

export const CLEAN_CUSTOM_ATTRIBUTES = 'CLEAN_CUSTOM_ATTRIBUTES';
export const cleanCustomAttributes = () => ({
    type: CLEAN_CUSTOM_ATTRIBUTES,
});

export const GET_CUSTOM_ATTRIBUTES_CONTACT = 'GET_CUSTOM_ATTRIBUTES_CONTACT';
export const getCustomAttributesContact = (parentType, visible) => ({
    type: GET_CUSTOM_ATTRIBUTES_CONTACT,
    payload: { parentType, visible }
});

export const GET_CUSTOM_ATTRIBUTES_CONTACT_SUCCESS = 'GET_CUSTOM_ATTRIBUTES_CONTACT_SUCCESS';
export const getCustomAttributesContactSuccess = (customAttributesContact=[]) => ({
    type: GET_CUSTOM_ATTRIBUTES_CONTACT_SUCCESS,
    payload: { customAttributesContact }
});

export const GET_CUSTOM_ATTRIBUTES_CONTACT_FAILURE = 'GET_CUSTOM_ATTRIBUTES_CONTACT_FAILURE';
export const getCustomAttributesContactFailure = (error={}) => ({
    type: GET_CUSTOM_ATTRIBUTES_CONTACT_FAILURE,
    payload: { error }
});